import { Card, Typography } from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
// import StarIcon from "@mui/icons-material/Star";

const ReviewCard = ({ title, description, reviewCount }) => {
  // const numberOfFilledStars = 5;

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={title}
        initial={{ opacity: 0.4, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0.1, y: 20 }}
        transition={{ duration: 0.5 }}
      >
        <Card
          sx={{
            p: 3,
            borderRadius: 3,
            border: "1px solid",
            borderColor: "border.lighter",
            boxShadow: "none",
            bgcolor: "white",
            minHeight: "8.3125rem",
          }}
        >
          {/* Title */}
          <Typography
            variant="h6"
            component="div"
            sx={{
              fontWeight: "bold",
              fontSize: "18px",
              mb: 1,
            }}
          >
            {title}
          </Typography>

          {/* Description */}
          <Typography variant="body" component={"p"} color="text.secondary">
            {description}
          </Typography>

          {/* <Divider sx={{ my: 2 }} />

          <Stack justifyContent="center" alignItems="center">
            <Stack direction="row" alignItems="center" spacing={0.5}>
              {[...Array(numberOfFilledStars)].map((_, index) => (
                <StarIcon
                  key={index}
                  sx={{ color: "button.star", fontSize: "1.21rem" }}
                />
              ))}
              <Typography variant="body" color="text.main">
                Based on
              </Typography>

              <Link
                href="#"
                underline="always"
                sx={{ fontSize: "0.875rem", color: "button.link" }}
              >
                <Typography variant="body">{reviewCount} reviews</Typography>
              </Link>
            </Stack>
          </Stack> */}
        </Card>
      </motion.div>
    </AnimatePresence>
  );
};

export default ReviewCard;
